module.exports = __webpack_public_path__ + "img/V15.b9efbff7.jpg";